module.exports = __webpack_public_path__ + "img/ercode_noaddress.1c2f674c.png";